(angular => {
  "use strict";

  angular.module("ActivityPremium").component("activitiesPremium", {
    templateUrl: 'admin/activityPremium/list/general/general.html',
    controller: [
      "Loader",
      "Toast",
      "EventService",
      "EventCompanyService",
      "ActivityPremiumService",
      ListCtrl
    ]
  });

  function ListCtrl(Loader, Toast, eventService, eventCompanyService, activityPremiumService) {

    eventService.current().then(event => {
      this.event = event;
    });

    // listPremium() já devolve SÓ as empresas com spots_activity_premium > 0
    // (resposta enxuta) — antes usava list() = TODAS as empresas do evento, que
    // em eventos grandes (FT2026) estourava o HTTP/2 ("erro inesperado").
    Loader.add(eventCompanyService.listPremium()).then(eventCompanies => {
      activityPremiumService.listWithParticipants().then(activities => {
        activities = activities.filter(a => a.attendance_list === true);
        this.eventCompanies = eventCompanies;
        this.eventCompanies.map(e => e.activities = activities);
      });
    });

  }
})(angular || {});
